module.exports = "//static.hsappstatic.net/AdsUI/static-1.38297/imgs/play-embed-academy-exp.svg"